export class ApplicationAgentDto {
    id: number;
    name: string;
    strAddr: string;
    city: string;
    state: string;
    zip: string;
    contact: string;
    phone: string;
    altPhone: string;
    fax: string;
    email: string;
    addrUnit: string;
    sign: boolean;
    signNoNeed: boolean;
    public create() {
        return {
            id: 0,
            name: '',
            strAddr: '',
            city: '',
            state: '',
            zip: '',
            contact: '',
            phone: '',
            altPhone: '',
            fax: '',
            email: '',
            addrUnit: '',
            sign: false,
            signNoNeed: false
        }
    }
}
